import React, { Component } from "react";
import "./App.css";
import Header from "./Header";
import Title from "./Title";
import FrameAreaLeft from "./FrameAreaLeft";
import FrameAreaRight from "./FrameAreaRight";
import Tabs from "./Tabs/Tabs";
import AdditionalInfo from "./AdditionalInfo";
import Footer from "./Footer";
import { getPlaqueLength, getPlaqueSize } from "./Helpers/Helpers";
import { connect } from "react-redux";
import ReactPixel from "react-facebook-pixel";
import ScrollToTop from "react-scroll-up";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lgShow: false,
      show: false
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.getFrameSize = this.getFrameSize.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.getFrameSize();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("750285538674235");
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.selectedFrame !== this.props.selectedFrame ||
      prevProps.selectedTopMat !== this.props.selectedTopMat ||
      prevProps.selectedMiddleMat !== this.props.selectedMiddleMat ||
      prevProps.middleMatGapInCM !== this.props.middleMatGapInCM ||
      prevProps.selectedMatSize !== this.props.selectedMatSize ||
      prevProps.matOuterWidth !== this.props.matOuterWidth ||
      prevProps.matOuterHeight !== this.props.matOuterHeight ||
      prevProps.plaqueUpdated !== this.props.plaqueUpdated
    ) {
      this.getFrameSize();
    }

    if (prevProps.selectedmatBoard !== this.props.selectedmatBoard) {
      this.getMatOuterSize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight
      }
    });
  }

  getMatOuterSize() {
    const { selectedmatBoard } = this.props;
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        matOuterWidth: parseFloat(
          selectedmatBoard.getIn(["mat_size", "width"])
        ),
        matOuterHeight: parseFloat(
          selectedmatBoard.getIn(["mat_size", "height"])
        ),
        matBoardWindowSize: selectedmatBoard.get("number_of_windows"),
        matUpdated: this.props.matUpdated === 1 ? 0 : 1
      }
    });
  }

  getFrameSize() {
    const {
      selectedMatSize,
      selectedMiddleMat,
      middleMatGapInCM,
      selectedmatBoard,
      selectedFrame,
      matOuterWidth,
      matOuterHeight,
      plaqueValues,
      matBoardWindowSize
    } = this.props;
    if (parseFloat(matOuterWidth) > 0 && parseFloat(matOuterHeight) > 0) {
      let frameWidth = parseFloat(matOuterWidth);
      let frameHeight = parseFloat(matOuterHeight);

      // Middle Mat
      let matDimension = 0;
      /* if (parseFloat(selectedMatSize) === 2)
                matDimension = parseFloat(middleMatGapInCM) * (parseFloat(matBoardWindowSize) * 2); */

      frameWidth = frameWidth + matDimension;
      frameHeight = frameHeight + matDimension;

      const windowsFullDimension = frameWidth + frameHeight;

      this.props.dispatch({
        type: "SET_STATE",
        state: {
          windowDimensionW: frameWidth,
          windowDimensionH: frameHeight,
          windowsFullDimension: windowsFullDimension
        }
      });

      var frameFullDimension = 0;
      if (selectedFrame.size > 0) {
        const dimensions = selectedFrame.get("dimensions");
        let frameDimensions = 0;
        if (dimensions !== undefined)
          frameDimensions = parseFloat(dimensions.get("width")) * 2;

        frameFullDimension = windowsFullDimension + frameDimensions;

        this.props.dispatch({
          type: "SET_STATE",
          state: {
            frameSizeW: frameWidth + frameDimensions,
            frameSizeH: frameHeight + frameDimensions,
            frameFullDimension: frameFullDimension
          }
        });
      } else {
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            frameSizeW: 0,
            frameSizeH: 0,
            frameFullDimension: 0
          }
        });
      }

      // Mat Board Price Calculations
      const priceMatBoard = selectedmatBoard.get("price");
      if (priceMatBoard !== undefined) {
        const { selectedmatBoard } = this.props;
        let matBoardPrice = 0;
        let fixed_price = 0;

        if (windowsFullDimension < 105)
          matBoardPrice = windowsFullDimension * parseFloat(priceMatBoard);
        else if (windowsFullDimension >= 105 && windowsFullDimension < 140)
          matBoardPrice =
            windowsFullDimension * 0.01 +
            windowsFullDimension * parseFloat(priceMatBoard);
        else if (windowsFullDimension >= 140 && windowsFullDimension < 200)
          matBoardPrice =
            windowsFullDimension * 0.05 +
            windowsFullDimension * parseFloat(priceMatBoard);
        else if (windowsFullDimension >= 200)
          matBoardPrice =
            windowsFullDimension * 0.15 +
            windowsFullDimension * parseFloat(priceMatBoard);

        for (var i = 0; i < selectedmatBoard.get("number_of_windows"); i++) {
          fixed_price += parseFloat(
            selectedmatBoard.getIn(["mat_data", i, "fixed_price"])
          );
        }

        this.props.dispatch({
          type: "SET_STATE",
          state: {
            matBoardPrice: (matBoardPrice + fixed_price).toFixed(2)
          }
        });

        // Middle Mat
        if (selectedMiddleMat.size > 0 && parseFloat(selectedMatSize) === 2) {
          this.props.dispatch({
            type: "SET_STATE",
            state: {
              middleMatTotal: (matBoardPrice + fixed_price).toFixed(2)
            }
          });
        }
      }

      // Plauqe Calculations
      if (selectedmatBoard.get("has_plaque") === "yes") {
        const { plaqueSize } = this.props;
        const plaque_fixed_price = parseFloat(
          selectedmatBoard.getIn([getPlaqueSize(plaqueSize), "fixed_price"])
        );
        const plaque_price_per_letter = parseFloat(
          selectedmatBoard.getIn([
            getPlaqueSize(plaqueSize),
            "price_per_letter"
          ])
        );
        if (plaque_fixed_price !== "" || plaque_price_per_letter !== "") {
          const plaqueLength = getPlaqueLength(plaqueValues);
          const plaqueTotal =
            plaque_fixed_price + plaque_price_per_letter * plaqueLength;
          this.props.dispatch({
            type: "SET_STATE",
            state: {
              plaqueTotal: plaqueTotal.toFixed(2)
            }
          });
        }
      } else {
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            plaqueTotal: 0
          }
        });
      }

      // Frame Price Calculations
      const priceFrame = selectedFrame.get("price");
      if (priceFrame !== undefined) {
        let framePrice = 0;
        if (windowsFullDimension < 105)
          framePrice = windowsFullDimension * parseFloat(priceFrame);
        else if (windowsFullDimension >= 105 && windowsFullDimension < 140)
          framePrice =
            windowsFullDimension * 0.16 +
            windowsFullDimension * parseFloat(priceFrame);
        else if (windowsFullDimension >= 140 && windowsFullDimension < 200)
          framePrice =
            windowsFullDimension * 0.25 +
            windowsFullDimension * parseFloat(priceFrame);
        else if (windowsFullDimension >= 200)
          framePrice =
            windowsFullDimension * 0.33 +
            windowsFullDimension * parseFloat(priceFrame);

        this.props.dispatch({
          type: "SET_STATE",
          state: {
            frameTotal: framePrice.toFixed(2)
          }
        });
      }
    }
  }

  render() {
    return (
      <div className="main-content-outer">
        <div className="container-fluid">
          <div className="row">
            <Header {...this.props} />
            <Title {...this.props} />
            <div className="farme_cust full_width">
              <div className="container">
                <div className="row">
                  <FrameAreaLeft {...this.props} />
                  <FrameAreaRight {...this.props} />
                </div>
              </div>
            </div>
            <Tabs {...this.props} />
            <AdditionalInfo />
            <Footer {...this.props} />
            <ScrollToTop showUnder={100}>
              <button title="Back to top" className="scroll">
                <span className="arrow-up glyphicon glyphicon-chevron-up"></span>
              </button>
            </ScrollToTop>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    frameProducts: state.get("frameProducts"),
    productsCount: state.get("productsCount"),
    frameCategories: state.get("frameCategories"),
    displayCategory: state.get("displayCategory"),
    catProCount: state.get("catProCount"),
    frameLoading: state.get("frameLoading"),
    selectedFrame: state.get("selectedFrame"),
    frameTotal: state.get("frameTotal"),
    frameSizeH: state.get("frameSizeH"),
    frameSizeW: state.get("frameSizeW"),
    frameFullDimension: state.get("frameFullDimension"),
    canvasImage: state.get("canvasImage"),
    canvasThumbImage: state.get("canvasThumbImage"),
    imageSizeError: state.get("imageSizeError"),

    glasses: state.get("glasses"),
    selectedGlass: state.get("selectedGlass"),
    glassTotal: state.get("glassTotal"),
    selectedGlassName: state.get("selectedGlassName"),

    printing: state.get("printing"),
    selectedPrint: state.get("selectedPrint"),
    printTotal: state.get("printTotal"),
    selectedPrintName: state.get("selectedPrintName"),
    matPrint: state.get("matPrint"),

    wallcolor: state.get("wallcolor"),

    roomImages: state.get("roomImages"),
    selectedRoomImage: state.get("selectedRoomImage"),

    mats: state.get("mats"),
    matView: state.get("matView"),
    selectedTopMat: state.get("selectedTopMat"),
    selectedMiddleMat: state.get("selectedMiddleMat"),
    selectedMatSize: state.get("selectedMatSize"),
    middleMatTotal: state.get("middleMatTotal"),
    matsLoaded: state.get("matsLoaded"),
    matsUpdated: state.get("matsUpdated"),

    qty: state.get("qty"),
    cartQty: state.get("cartQty"),
    customizeQTY: state.get("customizeQTY"),
    cart1ItemTotal: state.get("cart1ItemTotal"),
    selectedTab: state.get("selectedTab"),

    viewportWidth: state.get("viewportWidth"),
    viewportHeight: state.get("viewportHeight"),
    rightFrameHeight: state.get("rightFrameHeight"),
    headerHeight: state.get("headerHeight"),
    leftWidth: state.get("leftWidth"),

    matWindowValues: state.get("matWindowValues"),
    matBoards: state.get("matBoards"),
    selectedmatBoard: state.get("selectedmatBoard"),
    matBoardPrice: state.get("matBoardPrice"),
    matBoardWindowSize: state.get("matBoardWindowSize"),
    windowSizes: state.get("windowSizes"),
    middleMatGapInCM: state.get("middleMatGapInCM"),
    windowDimensionW: state.get("windowDimensionW"),
    windowDimensionH: state.get("windowDimensionH"),
    windowsFullDimension: state.get("windowsFullDimension"),
    matOuterWidth: state.get("matOuterWidth"),
    matOuterHeight: state.get("matOuterHeight"),
    matOuterUpdated: state.get("matOuterUpdated"),
    matUpdated: state.get("matUpdated"),
    matWindowUpdated: state.get("matWindowUpdated"),
    updatingWindow: state.get("updatingWindow"),
    isGrid: state.get("isGrid"),
    displayCategoryMatt: state.get("displayCategoryMatt"),
    catMattProCount: state.get("catMattProCount"),
    mattProductsCount: state.get("mattProductsCount"),
    matCategories: state.get("matCategories"),

    plaqueValues: state.get("plaqueValues"),
    plaqueUpdated: state.get("plaqueUpdated"),
    plaqueError: state.get("plaqueError"),
    plaqueColour: state.get("plaqueColour"),
    plaqueSize: state.get("plaqueSize"),
    plaqueTotal: state.get("plaqueTotal"),
    matPlauqeValues: state.get("matPlauqeValues"),

    showMeHow: state.get("showMeHow"),
    equalSpacing: state.get("equalSpacing")
  };
};

export default connect(mapStateToProps)(App);
